import React from 'react';
import { Box, Container, Grid, Typography, Link } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'grey.900',
        color: 'white',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* About Section */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
              Koopjesjacht
            </Typography>
            <Typography variant="body2" sx={{ color: 'grey.400' }}>
              Discover participating venues, solve clues, compete with friends,
              and follow your progress through a real hunt.
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="/hunts" color="inherit" underline="hover">
                Browse Hunts
              </Link>
              <Link href="/register" color="inherit" underline="hover">
                Create Account
              </Link>
              <Link href="/login" color="inherit" underline="hover">
                Sign In
              </Link>
            </Box>
          </Grid>

          {/* Contact & Social */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
              Support
            </Typography>
            <Typography variant="body2" sx={{ color: 'grey.400' }}>
              Password recovery and provider-dependent features report clear configuration guidance when unavailable.
            </Typography>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Box sx={{ borderTop: '1px solid', borderColor: 'grey.800', mt: 4, pt: 3 }}>
          <Typography variant="body2" align="center" sx={{ color: 'grey.500' }}>
            © {new Date().getFullYear()} Koopjesjacht
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
